"use strict";

import onInitModulesInsScope from "../onInitModulesInScope";

export function init() {
    onInitModulesInsScope(function initInScope($scope) {
        $scope.find('.js-infoscreen-hover-preview').each(function () {
            let $hoverBox = $(this).find('.js-infoscreen-hover-preview__hover-box');
            let $iframe = $(this).find('.js-infoscreen-hover-preview__iframe');

            $hoverBox.on('mouseenter', function () {
                if ($iframe.attr('data-src')) {
                    $iframe.attr('src', $iframe.attr('data-src'));
                    $iframe.removeAttr('data-src');
                }
            });
        });
    });
}